import { createAction } from "@redux/actions/actionCreators";
import type { ProductOptionData } from "@features/products/helpers/variantHelpers";

const [useUpdateProductOption, updateProductOption] = createAction<{
  productUuid: string;
  index: number;
  option: ProductOptionData;
}>("product/updateOption");

export default useUpdateProductOption;
export { updateProductOption };
